"use strict";
// packages/types/src/invitation.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationStatus = void 0;
var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["PENDING"] = "PENDING";
    InvitationStatus["ACCEPTED"] = "ACCEPTED";
    InvitationStatus["EXPIRED"] = "EXPIRED";
    InvitationStatus["CANCELLED"] = "CANCELLED";
})(InvitationStatus || (exports.InvitationStatus = InvitationStatus = {}));
